import React, { useEffect, useState } from "react";
import "./styles.scss";

interface ToastProps {
    id: number;
    type: "SUCCESS" | "ERROR" | "WARNING" | string;
    text: string;
}

interface ConfirmProps {
    id: number;
    title?: string;
    message: string;
    buttons: {
        label: string;
        onClick: () => void;
    }[];
}

const GlobalAlerts: React.FC = () => {
    const [toasts, setToasts] = useState<ToastProps[]>([]);
    const [confirms, setConfirms] = useState<ConfirmProps[]>([]);

    useEffect(() => {
        const handleShowToast = (e: any) => {
            const { type, text } = e.detail;
            const newToast = { id: Date.now(), type, text };
            setToasts((prev) => [...prev, newToast]);

            // Auto dismiss toast after 4 seconds
            setTimeout(() => {
                setToasts((prev) => prev.filter((t) => t.id !== newToast.id));
            }, 4000);
        };

        const handleShowConfirm = (e: any) => {
            const options = e.detail;
            setConfirms((prev) => [...prev, { id: Date.now(), ...options }]);
        };

        window.addEventListener("show-toast", handleShowToast);
        window.addEventListener("show-confirm", handleShowConfirm);

        return () => {
            window.removeEventListener("show-toast", handleShowToast);
            window.removeEventListener("show-confirm", handleShowConfirm);
        };
    }, []);

    const removeConfirm = (id: number) => {
        setConfirms((prev) => prev.filter((c) => c.id !== id));
    };

    const getToastIcon = (type: string) => {
        switch (type) {
            case "SUCCESS": return "✔️";
            case "ERROR": return "✖️";
            case "WARNING": return "⚠️";
            default: return "🔔";
        }
    };

    return (
        <div className="global-alerts-container">
            {/* TOASTS (Top Right) */}
            <div className="toasts-wrapper">
                {toasts.map((toast) => (
                    <div key={toast.id} className={`custom-toast toast-${toast.type.toLowerCase()}`}>
                        <div className="toast-icon">{getToastIcon(toast.type)}</div>
                        <div className="toast-content">{toast.text}</div>
                    </div>
                ))}
            </div>

            {/* CONFIRM MODALS (Centered) */}
            {confirms.length > 0 && (
                <div className="confirm-overlay">
                    {confirms.map((confirm) => (
                        <div key={confirm.id} className="confirm-modal scale-in-center">
                            <div className="confirm-header">
                                <span className="confirm-icon">⚠️</span>
                                <h3>{confirm.title || "Atenção"}</h3>
                            </div>
                            <div className="confirm-body">
                                <p>{confirm.message}</p>
                            </div>
                            <div className="confirm-footer">
                                {confirm.buttons.map((btn, index) => (
                                    <button
                                        key={index}
                                        className={index === 0 ? "btn-primary-confirm" : "btn-secondary-confirm"}
                                        onClick={() => {
                                            if (btn.onClick) btn.onClick();
                                            removeConfirm(confirm.id);
                                        }}
                                    >
                                        {btn.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default GlobalAlerts;
